import { ROOT_URL, FETCH_ALL_DISTRICTS } from '../../constants';
import axios from 'axios';

export const fetchDistricts = (account) => {
  const url = `${ROOT_URL}/districts?accountId=${account.id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then(response => {
        dispatch({
          type: FETCH_ALL_DISTRICTS,
          districts: response.data
        })
      })
      .catch(err => console.log(err))
  }
};